import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe to translate an array of objects. By default it translates the 'label' attribute.
 * The pipe is impure to react to language changes.
 * 
 * Usage:
 * [options]="sortOptions | arrayTranslate"
 * [options]="otherOptions | arrayTranslate:'name'"
 */
@Pipe({
  name: 'arrayTranslate',
  pure: false // Important: React to language changes
})
export class ArrayTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(array: any[], attributeName: string = 'label'): any[] {
    if (!array || !Array.isArray(array)) {
      return array;
    }
    
    return array.map(item => ({
      ...item,
      [attributeName]: this.translateService.instant(item[attributeName])
    }));
  }
}
